import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '@/store/index'
import $util from '@/utils/utils'
import version from '@/utils/versionUpdate';
import addWebLogs from '@/utils/addWebLogs';
let productTitle = ''
let productDesc = ''
let dynamicData = JSON.parse(localStorage.getItem('gt6_dynamic'))
if (dynamicData) {
    productDesc = dynamicData.productDesc
    productTitle = dynamicData.productTitle
    window.productTitle = productTitle
} else {
    window.addEventListener('setItemEvent', (e) => {
        if ((e.key) == 'gt6_dynamic') {
            let data = JSON.parse(e.newValue)
            productDesc = data.productDesc
            productTitle = data.productTitle
            window.productTitle = productTitle
        }
    })
}
Vue.use(VueRouter)
const  originalPush  =  VueRouter.prototype.push

VueRouter.prototype.push  =   function  push(location)  {  
    return  originalPush.call(this,  location).catch(err  =>  err)
}
if (localStorage.getItem('accessToken')) {
    // store.commit('set_product_remain', localStorage.getItem('yisou3_remain') ? JSON.parse(localStorage.getItem('yisou3_remain')) : [])
    store.commit('set_token', localStorage.getItem('accessToken'))
    if (localStorage.getItem('gt6_user_info')) {
        store.commit('set_user_info', JSON.parse(localStorage.getItem('gt6_user_info')))
    }
}
const router = new VueRouter({
    mode: process.env.VUE_APP_ROUTER_MODE,
    base: process.env.VUE_APP_BASE_URL,
    routes
})
router.beforeEach((to, from, next) => {
    version.isNewVersion(to)
    // 添加路由浏览日志
    addWebLogs.addLog(from, to)
    //console.log("beform");
    //console.log(to.fullPath);
    //"http://localhost:8089/gt6/#/company/result?keyword=led&accessToken=xxx&type=1&c=0".replace("accessToken=.*$",'')
    if (to.meta.title) { //如果设置标题，拦截后设置标题
        if(to.path == '/home') {
            document.title = `${productTitle}-${to.meta.title}-${productDesc}`
        } else {
            document.title = to.meta.title+`-${productTitle}`
        }
    } else {
        document.title = `${productTitle}`
    }
    let toDepth = to.path.split('/').length
    let fromDepth = from.path.split('/').length
        // if (toDepth < fromDepth) {
        //   store.commit('set_keep_alive_arr', from.name)
        //   // from.meta.keepAlive = false
        //   // to.meta.keepAlive = true
        // } else{
        //   store.commit('set_keep_alive_arr', from.name)
        // }
        // next()
    if (to.matched.some(r => r.meta.requireAuth)) {
        if (localStorage.getItem("accessToken")) {
            next()
        } else {
            // next()
            console.log("router-login");
            $util.loginOutUrl(to.fullPath);
        }
    } else {
        next()
    }
})
router.afterEach((to,from,nex) => {
    window.scrollTo(0, 0);
    // 添加路由浏览日志
    // addWebLogs.addLog(from, to)
})
export default router
